import React from 'react';
import { useRegistrationData } from './useRegistrationData';
import { ESIGNATURE_TYPE } from '../../../redux/actions/rootAction';
import { signmeRegisterFormStructure } from './signme/signmeRegisterFormStructure';
import { atrustRegisterFormStructure } from './atrust/atrustRegisterFormStructure';

function withESignatureUserData(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return props => {
    // eslint-disable-next-line react/prop-types
    const { qesProvider, signatureProcessItem, currentRecipientData } = props;
    let signatureFields = [];
    switch (qesProvider) {
      case ESIGNATURE_TYPE.SIGNME:
        signatureFields = signmeRegisterFormStructure;
        break;
      case ESIGNATURE_TYPE.YES:
        break;
      case ESIGNATURE_TYPE.ATRUST:
        signatureFields = atrustRegisterFormStructure;
        break;
      default:
        break;
    }
    const { registrationData } = useRegistrationData(
      // eslint-disable-next-line react/prop-types
      signatureProcessItem?.id,
      signatureFields,
      currentRecipientData
    );

    let userData = {};
    switch (qesProvider) {
      case ESIGNATURE_TYPE.SIGNME:
      case ESIGNATURE_TYPE.ATRUST:
        userData = {
          qesFirstName: registrationData.get('firstName'),
          qesLastName: registrationData.get('lastName'),
          userName:
            registrationData.get('lastName') &&
            registrationData.get('firstName')
              ? `${registrationData.get('lastName')} ${registrationData.get(
                  'firstName'
                )}`
              : registrationData.get('userName'),
          userEmail: registrationData.get('email')
        };
        break;
      case ESIGNATURE_TYPE.YES:
        break;
      default:
        break;
    }
    return <WrappedComponent {...props} eSignatureRecipientData={userData} />;
  };
}

export default withESignatureUserData;
